import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { getStoredGames, generateSitemap } from '../api/gameHistory';

const {
  FiClock,
  FiDatabase,
  FiExternalLink,
  FiMap,
  FiAward,
  FiFilm
} = FiIcons;

const Footer = ({ error }) => {
  const navigate = useNavigate();

  const handleSitemapView = () => {
    const games = getStoredGames();
    const xml = generateSitemap(games);
    const blob = new Blob([xml], { type: 'application/xml' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank', 'noopener,noreferrer');
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  return (
    <div className="mt-4 flex flex-col gap-3 border-t border-[#8aa890] pt-4">
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
        <div className="flex flex-wrap gap-4 text-[10px] font-medium tracking-wider text-[#a9c9b1] sm:text-xs">
          <div className="flex items-center gap-1.5">
            <SafeIcon icon={FiClock} size={11} className="text-[#658d71]" />
            <span><span className="font-bold text-[#d8ceb3]">Refresh:</span> 30s</span>
          </div>
          <button
            type="button"
            onClick={() => navigate('/history')}
            className="flex items-center gap-1.5 transition-colors hover:text-[#d8ceb3]"
          >
            <SafeIcon icon={FiDatabase} size={11} className="text-[#658d71]" />
            <span className="font-bold">Game History</span>
          </button>
          <button
            type="button"
            onClick={() => navigate('/franchise')}
            className="flex items-center gap-1.5 transition-colors hover:text-[#d8ceb3]"
          >
            <SafeIcon icon={FiAward} size={11} className="text-[#658d71]" />
            <span className="font-bold">Franchise History</span>
          </button>
          <button
            type="button"
            onClick={() => navigate('/content')}
            className="flex items-center gap-1.5 transition-colors hover:text-[#d8ceb3]"
          >
            <SafeIcon icon={FiFilm} size={11} className="text-[#658d71]" />
            <span className="font-bold">News & Highlights</span>
          </button>
          <button
            type="button"
            onClick={handleSitemapView}
            className="flex items-center gap-1.5 transition-colors hover:text-[#d8ceb3]"
            title="View sitemap.xml in browser"
          >
            <SafeIcon icon={FiMap} size={11} className="text-[#658d71]" />
            <span className="font-bold">View Sitemap</span>
          </button>
        </div>

        <div className="flex flex-col items-start gap-0.5 sm:items-end">
          <span className="text-[9px] font-bold uppercase tracking-widest text-[#658d71]">
            Created by
          </span>
          <a
            href="https://shawnryder.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-1 text-xs font-black uppercase tracking-widest text-[#d8ceb3] transition-colors hover:text-white"
          >
            Shawn Ryder
            <SafeIcon
              icon={FiExternalLink}
              size={11}
              className="text-[#658d71] transition-colors group-hover:text-[#a9c9b1]"
            />
          </a>
        </div>
      </div>

      {error && (
        <div className="text-center text-xs tracking-wider text-[#e6a8a8]">
          {error}
        </div>
      )}
    </div>
  );
};

export default Footer;